import React from 'react';
import { styled } from '@mui/material';
import { StyledColumnBox } from '../theme/StyledElements';
import { ClientTable } from '../components/Table/ClientTable';

const StyledBox = styled(StyledColumnBox)(() => ({
    alignItems: 'center',
    marginBottom: '60px'
}));

export function Clients(): React.ReactElement {
    return (
        <StyledBox sx={{ marginLeft: '20px' }}>
            <ClientTable />
        </StyledBox>
    );
}
